import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { Observable } from "rxjs";
import { database } from "firebase";
import { map, tap } from "rxjs/operators";
import { Obra } from "../models/entities/obra";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ObraService {
  public path: string;
  public constructor(
    public angularFireDatabase: AngularFireDatabase,
    public http: HttpClient
  ) {
    this.path = "obras";
  }

  public save(obra: Obra): Promise<any> {
    return this.angularFireDatabase.list<Obra>(this.path).push(obra);
  }
  // Funcion para crear ficha en el servidor sql
  public save2(obra: Obra): Promise<any> {
    const urlProd = "https://api-mssql.herokuapp.com/api";
    const urlDev = "http://localhost:5000/api";
    return this.http
      .post(`${urlProd}/save-datasheet`, obra)
      .pipe(
        map((resp: any) => {
          resp;
        })
      )
      .toPromise();
  }
  // Funcion para actualizar ficha en el servidor sql
  public updateFicha(obra: Obra): any {
    const urlProd = "https://api-mssql.herokuapp.com/api";
    const urlDev = "http://localhost:5000/api";

    return this.http.post(`${urlProd}/update-datasheet`, obra).pipe(
      map((resp: any) => {
        resp;
      })
    );
  }

  public update(keyObra: string, obra: Obra): Promise<any> {
    return this.angularFireDatabase.list<Obra>(this.path).update(keyObra, obra);
  }

  public remove(key: string): Promise<any> {
    return this.angularFireDatabase.list<Obra>(this.path).remove(key);
  }

  public findByKeyEstado(key: string): Observable<Obra[]> {
    let query = (ref: database.Reference): database.Query => {
      return ref.orderByChild("estado/key").equalTo(key);
    };
    return this.executeQuery(query);
  }

  public findByKey(key: string): Observable<Obra> {
    return this.angularFireDatabase
      .object<Obra>(this.path + "/" + key)
      .snapshotChanges()
      .pipe(
        map(
          (c) =>
            ({
              key: c.payload.key,
              ...c.payload.val(),
            } as Obra)
        )
      );
  }

  /** Metodo utilizado para obtener las obras a partir del keyLevantamientoObra */
  public findByKeyLevantamientoObra(
    keyLevantamientoObra: string
  ): Observable<Obra> {
    return this.angularFireDatabase
      .list<Obra>(this.path, (ref: database.Reference) =>
        ref.orderByChild("keyLevantamientoObra").equalTo(keyLevantamientoObra)
      )
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as Obra)
          )
        ),
        map((obras: Obra[]) => obras[0])
      );
  }

  public executeQuery(createQuery: any): Observable<Obra[]> {
    return this.angularFireDatabase
      .list<Obra>(this.path, (ref: database.Reference) => createQuery(ref))
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as Obra)
          )
        )
      );
  }

  public findAll(): Observable<Obra[]> {
    return this.angularFireDatabase
      .list<Obra>(this.path)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as Obra)
          )
        )
      );
  }

  public findByRegistro(registroSHCP: any): Observable<Obra> {
    return this.angularFireDatabase
      .list<Obra>(this.path, (ref: database.Reference) =>
        ref.orderByChild("registroSHCP").equalTo(registroSHCP)
      )
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as Obra)
          )
        ),
        map((obra: Obra[]) => obra[0])
      );
  }

  public selectByKey(keyLevantamientoObra: string) {
    return this.angularFireDatabase.list<Obra>(
      this.path,
      (ref: database.Reference) =>
        ref.orderByChild("keyLevantamientoObra").equalTo(keyLevantamientoObra)
    );
  }
}
